define(function (require) {
    "use strict";

    var LE = require("app");
    var MyProfileDialogLayout = require("manager-views/my-profile/MyProfileDialogLayout");
    var MyProfileView = require("manager-views/my-profile/MyProfileView");
    var BaseModel = require("models/BaseModel");
    var UserModel = require("models/entities/UserModel");
    var NoData = require("ui.components/no-data/NoData");
    var Page = require("ui.components/page/Page");
    var SettingsCollection = require("collections/SettingsCollection");
    var LanguageManager =  require("LanguageManager");
    var MyProfileController = {};
    var Settings = require("codeTables/settings.json");
    var SiteSettingsModel = require("models/SiteSettingsModel");

    var that;
    var userSettingsCollection;
    var mergedSettingsCollection;
    var onSuccessfulMyDetailsDataFetched;

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        MyProfileController = Marionette.Controller.extend({

            isMyUser: true,

            initialize: function () {
                that = this;
                this.userProfileChanged = false;
                this.userId = LE.sessionManager.getUserId();
                userSettingsCollection = new SettingsCollection([], {contextType: Settings.CONTEXT_TYPE.USER, contextId: this.userId, contextCascading: false});
                mergedSettingsCollection = new SettingsCollection([], {contextType: Settings.CONTEXT_TYPE.USER, contextId: this.userId, contextCascading: true});
                this.channel = LEManager.media.channel("myProfile");
            },

            _initPageComponent: function(){
                that.profileViewPage =  new Page({
                    moduleName:LEManager.moduleName,
                    context:LE.context,
                    isPermanent: true,
                    view: null,
                    permutation: Page.PERMUTATION.Dialog,
                    header:{
                        title: LE.translator.translate("LEManager.manager.my.profile.view.title.my.details"),
                        description:LE.translator.translate("LEManager.manager.my.profile.view.description")
                    }
                });
            },

            show: function() {
                that.profileViewPage.showLoader();
                this.listenTo(Backbone.history, "route", this._checkIfCloseLPTagPage);

                onSuccessfulMyDetailsDataFetched = _.after(3,function(){
                    showMyDetails();
                });
                this.userModel = new UserModel({id:that.userId}, {isMyUser: that.isMyUser});

                this.userModel.fetch({
                    success: _.bind(this._onFetchUserSuccess, this),
                    error:  _.bind(this._onFetchUserError, this)
                });

                _getUserSettingsCollection();
                _getMergedSettingsCollection();
            },

            _onFetchUserSuccess: function(model, response, options) {
                onSuccessfulMyDetailsDataFetched();
            },
            _onFetchUserError: function(model, response, options) {
                that.onCancel();
                LEManager.notifier.showError({content : LE.translator.translate("LEManager.profile.error.retrieve.details"), container : ".work-area-wrapper"});
            },

            getMainView:function () {
                this._initPageComponent();
                return this.profileViewPage;
            },

            onCancel: function() {
                that.profileViewPage.close();
                LEManager.router.navigateBack();
            },

            _afterSave: function() {
                this.stopListening(this.userModel, "invalid");
                this.profileViewPage.closeLoader();
            }
        });

        function _getUserSettingsCollection() {
            var settingsOptions = {};
            settingsOptions.groups = Settings.SETTING_GROUP.myDetailsSettings;
            settingsOptions.success = onSuccessfulMyDetailsDataFetched;
            settingsOptions.error = _onUserSettingsFetchError;
            userSettingsCollection.fetch(settingsOptions);
        }

        function _getMergedSettingsCollection() {
            var settingsOptions = {};
            settingsOptions.groups = Settings.SETTING_GROUP.myDetailsSettings;
            settingsOptions.success = onSuccessfulMyDetailsDataFetched;
            settingsOptions.error = _onUserSettingsFetchError;
            mergedSettingsCollection.fetch(settingsOptions);
        }

        function showMyDetails() {
            var myProfileView = new MyProfileView({ model: that.userModel, settingsCollection: mergedSettingsCollection});
            that.profileViewPage.setInsideView(myProfileView);

            that.listenTo(myProfileView, MyProfileView.TRIGGERING.CANCEL_BUTTON_CLICKED, that.onCancel);
            that.listenTo(myProfileView, MyProfileView.TRIGGERING.SAVE_BUTTON_CLICKED, saveMyDetails);
            that.profileViewPage.closeLoader();
        }

        function saveMyDetails(profileViewData){
            LEManager.logger.info("MyProfileController >> saveMyDetails >> START");
            that.profileViewPage.showLoader();
            if (profileViewData && profileViewData.userData) {
                that.userModel.setDisplayName(profileViewData.userData.displayName);
                that.userModel.setEmail(profileViewData.userData.email);
                that.userModel.setNickName(profileViewData.userData.nickName);
                that.userModel.setOldPassword(profileViewData.userData.oldPassword);

                if (profileViewData.userData.password && profileViewData.userData.password !== "") {
                    that.userModel.setPassword(profileViewData.userData.password);
                }

                if (!LE.sessionManager.hasProfilesFeature()) {
                    that.userModel.changePermissionGroup(that.userModel.getPermissionGroup());
                }

                that.userModel.save(null, {
                    isMyUser: that.isMyUser,
                    ignoreError: true,
                    success: function (model, response, xhr) {
                        LEManager.logger.info("MyProfileController >> savePerson >> success >> START");
                        if (that.userModel.get("displayName") !== profileViewData.displayName) {
                            userProfileChange("name", profileViewData.displayName);
                        }
                        if (that.userModel.get("nickName") !== profileViewData.nickName) {
                            userProfileChange("nickName", profileViewData.nickName);
                        }
                        _onPersonalDataSaveSuccess(profileViewData);
                        LEManager.logger.info("MyProfileController >> savePerson >> success >> END");
                    },
                    error: function (model, resp, options) {
                        LEManager.logger.error("MyProfileController >> savePerson >> error >> START");
                        that._afterSave();
                        var errorMessage = LE.translator.translate("LEFramework.something.went.wrong");
                        errorMessage = options.errorMessage?options.errorMessage:errorMessage;
                        var messageToShow = (!_.isEmpty(options.errorObject)) ? LEManager.getGeneralErrorMsg(options.errorObject) : errorMessage;
                        if (!_.isEmpty(messageToShow)) {
                            LEManager.notifier.showError(messageToShow);
                        }
                        if((!_.isEmpty(options.errorObject))) {
                            that.channel.trigger("profile:save:error", options.errorObject);
                        }
//                        that.profileViewPage.closeLoader();
//                        try {
//                            if (errors) {
//                                that.profileViewPage.getInsideView().onInvalid(model, errors);
//                            } else {
//                                LEManager.notifier.showError({content: LE.translator.translate("LEManager.error.update.details.password"), container: ".work-area-wrapper"});
//                            }
//                        } catch (ex) {
//                            LEManager.logger.error("MyProfileController >> savePerson >> error >> END");
//                            LEManager.notifier.showError({content: LE.translator.translate("LEManager.error.update.details.password"), container: ".work-area-wrapper"});
//                            throw ex;
//                        }
                        LEManager.logger.info("MyProfileController >> savePerson >> error >> END");
                    }
                });
            } else {
                that.profileViewPage.closeLoader();
                LEManager.notifier.showError(LE.translator.translate("LEFramework.something.went.wrong"));
                LEManager.logger.error("parameters missing", "MyProfileController: saveMyDetails");
                LEManager.logger.graph({name:"manager:MyProfileController:saveMyDetails:missingParameter"});
            }
            LEManager.logger.info("MyProfileController >> saveMyDetails >> END");
        }

        function _onPersonalDataSaveSuccess(profileViewData) {
            var isSettingsChanges = false;
            var TYPE_STRING = "2";
            var newLanguage, newTimeZone;
            if(profileViewData.language !== mergedSettingsCollection.get(Settings.SETTING_ID.LOCALE).getValue()){
                var langModel = userSettingsCollection.get(Settings.SETTING_ID.LOCALE);
                if(!langModel) {
                    langModel = new SiteSettingsModel({id: Settings.SETTING_ID.LOCALE, type: TYPE_STRING});
                    userSettingsCollection.push(langModel);
                }
                langModel.setValue(profileViewData.language);
                isSettingsChanges = true;
                newLanguage = profileViewData.language;
            }

            if(profileViewData.timeZone !== mergedSettingsCollection.get(Settings.SETTING_ID.TIME_ZONE).getValue()){
                var timeZoneModel = userSettingsCollection.get(Settings.SETTING_ID.TIME_ZONE);
                if(!timeZoneModel) {
                    timeZoneModel = new SiteSettingsModel({id: Settings.SETTING_ID.TIME_ZONE, type: TYPE_STRING});
                    userSettingsCollection.push(timeZoneModel);
                }
                timeZoneModel.setValue(profileViewData.timeZone);
                isSettingsChanges =  true;
                newTimeZone = profileViewData.timeZone;
            }

            if(isSettingsChanges) {
                userSettingsCollection.update({
                    success: function(collection, response, options){
                        _onSettingsSaveSuccess(newLanguage, newTimeZone);
                    },
                    error: _onSettingsSaveError
                });
            } else {
                _closeMyDetails();
            }
        }

        function _onSettingsSaveSuccess(newLanguage, newTimeZone) {
            if (newTimeZone) {
                LE.vent.trigger("siteSettings:timeZoneSwitched:userLevel", newTimeZone);
            }

            if(newLanguage) { //In case language setting changed we notify languageManager
                var optionsLanguage = {};
                optionsLanguage.success = _refreshLanguageSuccess;
                optionsLanguage.error = _refreshLanguageError;
                optionsLanguage.defaultLanguageForError = newLanguage;
                var languageManager = new LanguageManager();
                languageManager.reload(optionsLanguage);
            } else {
                _closeMyDetails();
            }
        }

        function _onSettingsSaveError() {
            that.profileViewPage.closeLoader();
            LEManager.notifier.showError({content : LE.translator.translate("LEManager.profile.error.update.regional.settings"), container : ".work-area-wrapper"});
        }

        function _refreshLanguageSuccess() {
            _closeMyDetails();
        }

        function _closeMyDetails() {
            that.profileViewPage.closeLoader();
            that.onCancel();
        }

        function _onUserSettingsFetchError() {
            _onFetchSettingsError();
        }

        function _onFetchSettingsError() {
            LEManager.logger.error("MyProfileController >> _getSettingsError >> error >> START");
            that.onCancel();
            LEManager.notifier.showError({content : LE.translator.translate("LEManager.profile.error.retrieve.details"), container : ".work-area-wrapper"});
            LEManager.logger.info("MyProfileController >> _getSettingsError >> error >> END");
        }

        function _refreshLanguageError() {
            LEManager.logger.error("MyProfileController >> _refreshLanguageFailed >> error >> START");
            _closeMyDetails();
            LEManager.logger.info("MyProfileController >> _refreshLanguageFailed >> error >> END");
        }

        function userProfileChange(field,value) {
            LE.context.set("user."+field, value);
            that.userProfileChanged = true;
        }
    });

    return MyProfileController;
});
